export interface SetCookieClientProps {
  key: string;
  value: string;
}

export function setCookieAction({ key, value }: SetCookieClientProps) {
  if (typeof document === 'undefined') return;

  const maxAgeSeconds = 30 * 24 * 60 * 60; // 秒に変換

  const cookieString = `${encodeURIComponent(key)}=${encodeURIComponent(
    value,
  )}; path=/; max-age=${maxAgeSeconds}`;
  document.cookie = cookieString;
}
